export default class GenerateShiftTimesheetPdfRequest {
    filename: string;
    shiftId: string;
    isIncludeContactDetails: boolean;
}